import React from 'react';
import { LucideIcon } from 'lucide-react';

interface QuickActionCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  theme?: 'blue' | 'green';
  onClick: () => void;
}

export const QuickActionCard: React.FC<QuickActionCardProps> = ({
  title,
  description,
  icon: Icon,
  theme = 'blue',
  onClick,
}) => {
  const themeColors = {
    blue: {
      hover: 'hover:border-blue-500 hover:bg-blue-50',
      bg: 'bg-blue-50',
      icon: 'text-blue-600',
    },
    green: {
      hover: 'hover:border-green-500 hover:bg-green-50',
      bg: 'bg-green-50',
      icon: 'text-green-600',
    },
  };

  const colors = themeColors[theme];

  return (
    <button
      onClick={onClick}
      className={`w-full p-6 border-2 border-gray-200 rounded-xl ${colors.hover} transition-all text-left group`}
    >
      <div className={`inline-flex items-center justify-center w-12 h-12 ${colors.bg} rounded-lg mb-4`}>
        <Icon className={`h-6 w-6 ${colors.icon}`} />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
      <p className="text-sm text-gray-600">{description}</p>
    </button>
  );
};
